"use strict";

function init() {
	$('.navbar-collapse.collapse.in > ul > li > a').on('click', () => {
		$('.navbar-toggle').trigger('click');
	});
}

module.exports = {
	init
};


// WEBPACK FOOTER //
// ./src/scripts/client/plugin/menu.js